import { INTERNALS, SUBINTERNALS } from "./routes.url";

export const makeChatUrl = (pathname: string, url: string, urlSumer: string) => {
    const internals = INTERNALS;
    const isInInternalPage = internals.some((p) => pathname?.includes(p));
    if (isInInternalPage) {
      const subInternals = SUBINTERNALS;
      const shouldBackTwo = subInternals.find((p) => pathname?.includes(p));
      if (shouldBackTwo === "/categoria/") {
        const pathnameItems = pathname.split("/");
        if (pathnameItems.indexOf("categoria") < pathnameItems.length - 2) {
          return `../../../catalogo/${urlSumer}/${url}`;
        }
      }
      if (shouldBackTwo) {
        return `../../catalogo/${urlSumer}/${url}`;
      }
      return `../catalogo/${urlSumer}/${url}`;
    }
    return `${urlSumer}/${url}`;
  };
  